import { ContentFilterValue } from './ContentFilters';
import { FilterObject } from '../product-lister';
import { ContentSearch } from '../ContentTypes';
import { Configurations } from '../AemConfigurationTypes';
import { UrlState } from '../UrlTypes';

export type ContentOverviewState = {
  tiles: ContentSearch;
  filters: Array<FilterObject>;
  types: Array<ContentFilterValue>;
  categories: Array<ContentFilterValue>;
  isLoading?: boolean;
  filtersPath?: string;
  hideAllFilters: boolean;
  hiddenTags: Array<string>;
  typeFilterOptions: number;
  typeFilterSortingOptions: number;
  categoryFilterOptions: number;
  categoryFilterSortingOptions: number;
  path?: string;
  tags?: Array<string>;
};

export type ContentListerRenderData = {
  configs: Configurations;
  store: {
    urlState: UrlState;
    tiles?: ContentSearch;
    filters?: Array<FilterObject>;
    types?: Array<ContentFilterValue>;
    categories?: Array<ContentFilterValue>;
  };
};
